// Copyright (c) 2016 Deere & Company

import PartRequestsSearchMain from './part-requests-search-main';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    allPartRequestsCount: state.partReturns.allPartReturns.partReturns.length,
    facets: state.partReturns.search.facets,
    filteredSearchResults: state.partReturns.search.filteredSearchResults,
    openPartRequestsCount: state.partReturns.openPartReturns.partReturns.length,
    searchByDropdown: state.partReturns.search.searchByDropdown,
    searchFilters: state.partReturns.search.searchFilters,
    searchQueryString: state.partReturns.search.searchQueryString,
    searchResults: state.partReturns.search.searchResults
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PartRequestsSearchMain);



// WEBPACK FOOTER //
// ./src/part-requests/search/components/part-requests-search-main/index.js